import { render, staticRenderFns } from "./Indicador.vue?vue&type=template&id=5f7275b2&"
import script from "./Indicador.vue?vue&type=script&lang=js&"
export * from "./Indicador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports